<template>
    <div class="subscribe-page cg ac" @click="getHome()">
    <a class="logo"><img src="static/images/logo1.png" /></a>
		<div class="unsub-btn mt100 por">
      <img class="mt100" src="../../static/images/img1.png" />
			<div class="mt100">
				<div class="register-t fs40 crfff fw7">Study smarter, not harder, with StudyGo!</div>
				<div class="button fs50 mt50">Register<img class="ml10" src="../../static/images/back.png"></div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
      Header
    },
    methods: {
      getHome(){
        window.location.href = 'http://gw.studygo.asia/channel/WAP/stgo';
      }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/subscribe.vue